import { render } from "./WaitInfo.vue?vue&type=template&id=59a093f6"
import script from "./WaitInfo.vue?vue&type=script&lang=js"
export * from "./WaitInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Transcend INNCOM/INNCOM Project/2103.musoon.mobile.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__